import React, { useMemo } from 'react';
import { useListBigQueryRoutines } from '../../../../query/acg/phase-1';
import moment from 'moment/moment';
import TablePagination from '../../../../components/ui/TablePagination';
import ReactTable from 'react-table';
import ManageDefaultValuesButton from './ManageDefaultValuesButton';
import SyncBQRoutineStatusButton from './SyncBQRoutineStatusButton';

export default function BQRoutineManagement() {
  const { data: routines, isLoading, isFetching } = useListBigQueryRoutines();
  const columnDefs = useMemo(() => {
    return [
      {
        id: 'routineName',
        Header: 'Routine Name',
        accessor: row => <b>{row.routineName}</b>,
      },
      {
        id: 'argumentCount',
        Header: () => (
          <p style={{ marginBottom: 0, textAlign: 'right ' }}>
            Number of Arguments
          </p>
        ),
        accessor: row => (
          <p style={{ marginBottom: 0, textAlign: 'right ' }}>
            {row.argumentCount}
          </p>
        ),
      },
      {
        id: 'lastUpdatedAt',
        Header: () => (
          <p style={{ marginBottom: 0, textAlign: 'center' }}>
            Last Updated At
          </p>
        ),
        accessor: row => (
          <p style={{ marginBottom: 0, textAlign: 'center' }}>
            {moment(row.lastUpdatedAt).format('YYYY-MM-DD HH:mm:ss')}
          </p>
        ),
      },
      {
        id: 'actions',
        Header: () => (
          <p style={{ marginBottom: 0, textAlign: 'center' }}>Actions</p>
        ),
        accessor: row => (
          <div className="flex flex-col flex-1 items-center">
            <ManageDefaultValuesButton routineName={row.routineName} />
          </div>
        ),
      },
    ];
  }, []);
  return (
    <>
      <SyncBQRoutineStatusButton />
      <ReactTable
        PaginationComponent={TablePagination}
        columns={columnDefs}
        data={routines}
        defaultPageSize={10}
        indexKey="id"
        loading={isLoading || isFetching}
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        pageSize={20}
        pageSizeOptions={[5, 10, 15, 20]}
        previousText={<i className="material-icons">chevron_left</i>}
        rowsSelectorText="Rows per page"
        showPageJump={false}
        showPageSizeOptions
        showPaginationBottom
        style={{ marginTop: 16 }}
      />
    </>
  );
}
